import toLower from 'ramda/src/toLower'
import CognitoUser from 'amazon-cognito-identity-js/lib/CognitoUser'
import AuthenticationDetails from 'amazon-cognito-identity-js/lib/AuthenticationDetails'

import userPool from 'root/src/client/logic/auth/util/userPool'

import determineAuth from 'root/src/client/logic/auth/thunks/determineAuth'

import afterLoginRouteSelector from 'root/src/client/logic/auth/util/afterLoginRouteSelector'
import setSession from 'root/src/client/logic/auth/util/setSession'
import authSelector from 'root/src/client/logic/auth/util/authSelector'
import pushRouteClient from 'root/src/client/logic/route/util/pushRouteClient'
import moment from 'moment'

import mixpanel from 'root/src/client/logic/analytics/mixpanel'
import { mixpanelEvents } from 'root/src/shared/constants/mixpanel'
import hasCreatorExtensionsSelector from 'root/src/client/logic/app/selectors/hasCreatorExtensionsSelector'
import obsExtensionAddedSelector from 'root/src/client/logic/creatorData/selectors/obsExtensionAddedSelector'
import {
	TRANSFER_ACCOUNT_ROUTE_ID,
} from 'root/src/shared/descriptions/routes/routeIds'
import authApi from 'root/src/shared/util/authApi'
import cognitoErrorHandler from 'root/src/client/logic/auth/util/cognitoErrorHandler'

const authApiLoginHandler = ({ email, password }) => async (resolve, reject) => {
	try {
		const { error: err, ...body } = await authApi.signIn({
			email,
			password,
		})

		if (err) {
			return reject(err)
		}

		return resolve(body)
	} catch (e) {
		return reject(e)
	}
}

const login = ({ email, password, redirectRoute }) => (dispatch, getState) => new Promise(
	async (resolve, reject) => {
		const correctedEmail = toLower(email)
		// if error - login with cognito and try again
		try {
			const res = await authApi.signIn({ email, password })
			return resolve(res)
		} catch (e) {
			const authenticationDetails = new AuthenticationDetails({
				Username: correctedEmail,
				Password: password,
			})
			const cognitoUser = new CognitoUser({
				Username: correctedEmail,
				Pool: userPool,
			})
			return cognitoUser.authenticateUser(authenticationDetails, {
				onSuccess: ({ idToken }) => pushRouteClient(
					{ routeId: TRANSFER_ACCOUNT_ROUTE_ID, query: { token: idToken.jwtToken } },
				),
				onFailure: cognitoErrorHandler(
					resolve,
					reject,
					async () => authApiLoginHandler({ email, password })(resolve, reject),
				),
				newPasswordRequired: () => cognitoUser
					.completeNewPasswordChallenge(password, {}, {
						onSuccess: () => login({ email, password, redirectRoute })(dispatch, getState),
					}),
			})
		}
	},
).then(async (session) => {
	setSession(authSelector(session))
	await dispatch(determineAuth())
	const afterLoginRoute = await afterLoginRouteSelector({
		redirectRoute,
		dispatch,
		getState,
	})
	const state = getState()
	mixpanel.identify(email)
	mixpanel.track(mixpanelEvents.login)
	if (hasCreatorExtensionsSelector(state)) {
		mixpanel.people.set_once({ addedTwitchExtension: moment().format() })
		mixpanel.track(mixpanelEvents.twitchExtension)
	}
	if (obsExtensionAddedSelector(state)) {
		mixpanel.people.set_once({ addedObsExtension: moment().format() })
		mixpanel.track(mixpanelEvents.obsExtension)
	}
	return pushRouteClient(afterLoginRoute)
})

export default login
